<template>
    <div>
        <common-content-spacer height="medium">
            <common-page-header
                size="large"
                :heading="$t('pages.terms.disclaimer.heading')"
                :isCenter="true"
            ></common-page-header>
            <div class="agrement-page">
                <common-content-spacer height="medium">
                    <div class="agrement-page__links">
                        <b v-html="$t('pages.terms.terms.privacy_policy_link')"></b>
                        <b v-html="$t('pages.terms.terms.terms_link')"></b>
                    </div>
                    <div>{{ $t('pages.terms.disclaimer.updated') }}</div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.websiteDisclaimer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.websiteDisclaimerDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.websiteDisclaimerRisk') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.externalLinksDisclaimer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.externalLinksDisclaimerDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.externalLinksDisclaimerPolicyMaker') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.externalLinksDisclaimerResponsibility') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.affiliatesDisclaimer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.affiliatesDisclaimerDescription') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.testimonialsDisclaimer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.testimonialsDisclaimerDescription') }}
                        </p>
                        <p>{{ $t('pages.terms.disclaimer.testimonialsDisclaimerResults') }}</p>
                        <p>
                            {{ $t('pages.terms.disclaimer.testimonialsDisclaimerSubmission') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.testimonialsDisclaimerViews') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.errorsAndOmissionsDisclaimer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.errorsAndOmissionsDisclaimerDescription') }}
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.errorsAndOmissionsDisclaimerLiability') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.guestContributorsDisclaimer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.guestContributorsDisclaimerDescription') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.logosAndTrademarksDisclaimer') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.logosAndTrademarksDisclaimerDescription') }}
                        </p>
                    </div>

                    <div>
                        <p>
                            <b>{{ $t('pages.terms.disclaimer.contactUs') }}</b>
                        </p>
                        <p>
                            {{ $t('pages.terms.disclaimer.contactUsDescription') }}
                        </p>
                    </div>
                    <div>
                        <p><b></b></p>
                    </div>
                </common-content-spacer>
            </div>
        </common-content-spacer>
    </div>
</template>

<style lang="scss">
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/mixins';

    .agrement-page {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        padding: 50px;
        max-width: 70%;
        margin: 0 auto;
        @include breakpoint(tablet) {
            max-width: 85%;
        }
        @include breakpoint(smartphone-large) {
            max-width: 100%;
        }
        &__links {
            display: flex;
            justify-content: space-evenly;
            @include breakpoint(smartphone-large) {
                justify-content: space-between;
            }
        }

        a {
            color: $color-link;
        }
    }
</style>
